export type MatterStatusType = 'DEFAULT_ACTIVE' | 'INACTIVE' |'ACTIVE';

export const MatterStatusTypesValue = {
    INACTIVE: 'INACTIVE'  as MatterStatusType,
    ACTIVE: 'ACTIVE'  as MatterStatusType,
    DEFAULT_ACTIVE: 'DEFAULT_ACTIVE'  as MatterStatusType
}